import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/contact-us/hero";
import ContactForm from "../components/contact-us/contact-form";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Contact Us | Regent Dental</title>
        <meta
          name="description"
          content="Get in touch with Regent Dental in West Yorkshire. Call, email, or visit us today to schedule your appointment or inquire about our dental services."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/contact-us"
        />
      </Helmet>
      <Navbar />
      <Header />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default Index;
